import { Node } from "prosemirror-model";
import { EditorState } from "prosemirror-state";

import { schema } from "@moment/prosemirror-schema";
import { env } from "@moment/state";

import { createPlugins } from "~/components/canvas/easel/prosemirror/plugins";

export const createEditorState = ({
	documentId,
	pageId,
	doc: rawDoc,
	ssr = false,
	version,
}: {
	documentId: string;
	pageId: string;
	doc: JsonObject;
	ssr?: boolean;
	version?: number;
}) => {
	// If this page is being SSR'ed, we want to remove compute_cells from the document
	// There is probably a better way to do this
	const doc = ssr
		? {
				...rawDoc,
				content: (rawDoc.content as JsonObject[])?.filter(
					(content) => content.type !== "compute_cell"
				),
			}
		: rawDoc;

	return EditorState.create({
		doc: Node.fromJSON(schema, doc),
		plugins: createPlugins({
			documentId,
			pageId,
			schema,
			readonly: !env.isDesktopApp && !env.isMobileApp,
			version,
		}),
	});
};
